import type { StoreApi } from 'zustand'
import type { AppState } from '@/store/rootTypes'
import { activeWorkspacePatch } from '@/store/workspace'
import { getOutfitConfig } from '@/data/outfitConfig'

type SetState = StoreApi<AppState>['setState']
type GetState = StoreApi<AppState>['getState']

export function createOutfitSlice(set: SetState, get: GetState): Pick<AppState, 'setOutfit' | 'unlockOutfit' | 'purchaseOutfit' | 'awardStarsForChapter'> {
  return {
    setOutfit: (outfit) => set((state) => {
      const patch = { currentOutfit: outfit }
      return { ...patch, ...activeWorkspacePatch(state, patch) }
    }),
    unlockOutfit: (outfit) => set((state) => {
      const unlockedOutfits = state.unlockedOutfits.includes(outfit) ? state.unlockedOutfits : [...state.unlockedOutfits, outfit]
      const ownedOutfits = outfit !== 'none' && !state.ownedOutfits.includes(outfit) ? [...state.ownedOutfits, outfit] : state.ownedOutfits
      const patch = { unlockedOutfits, ownedOutfits }
      return { ...patch, ...activeWorkspacePatch(state, patch) }
    }),
    purchaseOutfit: (outfit) => {
      const config = getOutfitConfig(outfit)
      if (!config) return false
      const state = get()
      if (state.ownedOutfits.includes(outfit)) return true
      if (state.stars < config.price) return false
      set((current) => {
        const stars = current.stars - config.price
        const ownedOutfits = [...current.ownedOutfits, outfit]
        const patch = { stars, ownedOutfits, student: { ...current.student, totalStars: stars } }
        return { ...patch, ...activeWorkspacePatch(current, patch) }
      })
      return true
    },
    awardStarsForChapter: (unitId, perfect) => {
      const state = get()
      const rewardKey = `chapter-stars-${unitId}`
      if (state.completedTasks[rewardKey]) return
      const stars = state.stars + (perfect ? 10 : 3)
      const patch = { stars, completedTasks: { ...state.completedTasks, [rewardKey]: true }, student: { ...state.student, totalStars: stars } }
      set((current) => ({ ...patch, ...activeWorkspacePatch(current, patch) }))
    },
  }
}
